export default __webpack_public_path__ + "static/media/14.ae5e6e8f.jpg";